"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UWPCapabilities = (function () {
    function UWPCapabilities() {
    }
    UWPCapabilities.prototype.hasLifecycleSuspension = function () {
        return true;
    };
    UWPCapabilities.prototype.hasNativeParentalPin = function () {
        return false;
    };
    UWPCapabilities.prototype.hasExternalAppsDisplay = function () {
        return false;
    };
    UWPCapabilities.prototype.hasVolumeControl = function () {
        return true;
    };
    UWPCapabilities.prototype.hasExternalAppsLaunch = function () {
        return false;
    };
    return UWPCapabilities;
}());
exports.UWPCapabilities = UWPCapabilities;
